import { getTutorials } from '../../../store/tutorials';
import { tutorialConstants } from '../../../utils/constants';
import { useAppSelector } from '../../../store/configureStore';

import Conditional from '../../common/conditional';
import Elevation from '../../themed/instruction-modals/elevation';

import authService from '../../../services/authService';
import classNames from './style.module.scss';

interface HeaderProps {
	subtitle?: string;
	buttonTitle?: string;
	buttonIcon?: string;
	onCTAClick?: () => void;
	canViewCTA?: boolean;
}

const Header = (props: HeaderProps): JSX.Element => {
	const { activeTutorial } = useAppSelector(getTutorials);

	const user = authService.getCurrentUser();
	const isElevated = activeTutorial === tutorialConstants.CREATE_PROJECT;

	return (
		<header className={classNames.header}>
			<div>
				<h1>
					Welcome, {user?.firstName} {user?.lastName}
				</h1>
				<Conditional isVisible={!!props.subtitle}>
					<p>{props.subtitle}</p>
				</Conditional>
			</div>

			<Conditional isVisible={props.canViewCTA as boolean}>
				<Conditional isVisible={!!props.onCTAClick}>
					<Elevation isElevated={isElevated}>
						<button
							className={classNames['cta-button']}
							onClick={props.onCTAClick}
						>
							<Conditional isVisible={!!props.buttonIcon}>
								<i className={'bi bi-' + props.buttonIcon}></i>
							</Conditional>

							<span>{props.buttonTitle}</span>
						</button>
					</Elevation>
				</Conditional>
			</Conditional>
		</header>
	);
};

export default Header;
